import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import { withTranslation } from 'react-i18next'

import TopNav from './TopNav'
import { pathname } from 'store/entities/router/selectors'

const mapStateToProps = createStructuredSelector({
  pathname,
})

export default withRouter(connect(mapStateToProps)(withTranslation()(TopNav)))
